import { mapGetters, mapActions } from 'vuex'

import Sidebar from '@/components/Sidebar/Sidebar.vue'

export default {
  name: 'Pipeline',
  components: {
    Sidebar
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'articles',
      'activeContentplan'
    ]),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    },
    contentplanId () {
      return parseInt(this.$route.params.contentplanId)
    },
    groupedArticles () {
      if (!this.articles) { return }

      return [
        {
          status: 'draft',
          label: 'Draft',
          articles: this.articles.filter(a => a.status === 'draft')
        }, {
          status: 'brief sent',
          label: 'Brief sent',
          articles: this.articles.filter(a => a.status === 'brief sent')
        }, {
          status: 'in review',
          label: 'In review',
          articles: this.articles.filter(a => a.status === 'in review')
        }, {
          status: 'published',
          label: 'Published',
          articles: this.articles.filter(a => a.status === 'published')
        }
      ]
    }
  },
  watch: {
    async $route () {
      this.loadData()
    }
  },
  methods: {
    ...mapActions([
      'loadArticles',
      'updateArticles'
    ]),
    async loadData () {
      document.title = 'Pipeline | ContentGecko'
      this.loadArticles({
        workspaceId: this.workspaceId,
        contentplanId: this.contentplanId,
        filterHasStatus: true
      })
    },
    startDrag: (evt, item) => {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('articleId', item.article_id)
    },
    async onDrop (evt, status) {
      const articleId = parseInt(evt.dataTransfer.getData('articleId'))
      // const item = this.articles.find(item => item.article_id === articleId)
      this.articles = this.articles.map(item => {
        if (item.article_id === articleId) {
          item.status = status
        }
        return item
      })
      await this.updateArticles({
        contentplanId: this.contentplanId,
        action: 'updateStatus',
        articleIds: [articleId],
        status
      })
      // item.status = status
      await this.loadData()
    }
  },
  async mounted () {
    await this.loadData()
  }
}
